function lmToggleHoganCandidateEmail() {
    var $checkbox = $('#lm_send_hogan_id');
    var $wrap = $('.hogan-id-delivery__email');
    var $email = $('#hogan_candidate_email');
    var $field = $('#hogan_candidate_email_field');

    if (!$checkbox.length || !$wrap.length) {
        return;
    }

    var checked = $checkbox.is(':checked');
    $wrap.prop('hidden', !checked);
    $email.prop('required', false);

    if (checked) {
        $field.addClass('validate-required');
    } else {
        $field.removeClass('validate-required woocommerce-invalid woocommerce-invalid-required-field');
    }
}

function lmEmailValueIsValid(selector) {
    var email = ($(selector).val() || '').trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function lmHoganCandidateEmailIsValid() {
    return lmEmailValueIsValid('#hogan_candidate_email');
}

function lmMarkEmailField(selector, valid) {
    var $field = $(selector);
    if (valid) {
        $field.removeClass('woocommerce-invalid woocommerce-invalid-required-field woocommerce-invalid-email');
        $field.addClass('woocommerce-validated');
    } else {
        $field.removeClass('woocommerce-validated');
        $field.addClass('woocommerce-invalid woocommerce-invalid-required-field');
    }
}

$(document).on('click', '.checkout--btn', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var now = parseInt($(this).attr('data-now'), 10);
    var step = parseInt($(this).attr('data-step'), 10);
    var isvalid = true;

    if (now === 1) {
        $('#checkout_step_1 .validate-required:visible input:not(#terms), #checkout_step_1 .validate-required:visible select').trigger('validate');
        if ($('#checkout_step_1 .woocommerce-invalid-required-field:visible').length) {
            isvalid = false;
        }
    }

    if (now === 2) {
        var reportEmailValid = lmEmailValueIsValid('#report_email_1');
        lmMarkEmailField('#report_email_1_field', reportEmailValid);
        if (!reportEmailValid) {
            isvalid = false;
        }

        if ($('#lm_send_hogan_id').is(':checked')) {
            var $wrap = $('.hogan-id-delivery__email');
            var hoganEmailValid = lmHoganCandidateEmailIsValid();
            if (!hoganEmailValid) {
                isvalid = false;
                $wrap.prop('hidden', false);
            }
            lmMarkEmailField('#hogan_candidate_email_field', hoganEmailValid);
        }
    }

    if (isvalid && step) {
        $('.checkout--step').addClass('inactive');
        $('#checkout_step_' + step).removeClass('inactive');
        if (now === 2) {
            $(document.body).trigger('update_checkout');
        }
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }
    return false;
});

function lmMoveCheckoutAdditionalFields() {
    var $fields = $('.woocommerce-additional-fields');
    var $step2 = $('#checkout_step_2');
    if ($fields.length && $step2.length && !$fields.parent().is($step2)) {
        $fields.prependTo($step2);
    }
}

lmMoveCheckoutAdditionalFields();

$(document).ready(function() {
    lmMoveCheckoutAdditionalFields();

    lmToggleHoganCandidateEmail();
    $(document).on('change', '#lm_send_hogan_id', function() {
        lmToggleHoganCandidateEmail();
        $(document.body).trigger('update_checkout');
    });

    // // Open shop dropdown on page load
    // if ($('.shop--dropdown').length) {
    //     setTimeout(function() {
    //         var $dropdown = $('.shop--dropdown');
    //         var $button = $dropdown.find('[popoverbutton="cover"]');
    //         var $content = $dropdown.find('[popovercontent="cover"]');
    //
    //         if ($button.length && $content.length) {
    //             $button.addClass('active');
    //             $content.slideDown();
    //         }
    //     }, 100);
    // }

    // Add "NEW" badge to orders menu item
    setTimeout(function() {
        var $ordersLink = $('.woocommerce-MyAccount-navigation-link--orders a');
        if ($ordersLink.length && !$ordersLink.find('.new-badge').length) {
            var isFrench = document.documentElement.lang.indexOf('fr') !== -1 || 
                          window.location.pathname.indexOf('/fr/') !== -1;
            var isGerman = document.documentElement.lang.indexOf('de') !== -1 || 
                          window.location.pathname.indexOf('/de/') !== -1 || 
                          (!isFrench && window.location.pathname.indexOf('/en/') === -1 && window.location.pathname.indexOf('/en') === -1);
            var badgeText = isFrench ? 'NOUVEAU' : (isGerman ? 'NEU' : 'NEW');
            $ordersLink.css({
                'display': 'flex',
                'justify-content': 'space-between',
                'align-items': 'center'
            });
            $ordersLink.append('<span class="new-badge" style="background-color: #e24403; color: white; font-size: 10px; font-weight: 600; padding: 2px 6px; border-radius: 4px; margin-left: 8px;">' + badgeText + '</span>');
        }
    }, 150);

    setTimeout(function() {
        if($('.wc-block-cart-item__remove-link')) {
            var btnText = $($('.wc-block-cart-item__remove-link')[0]).text();
            if(btnText) {
                $('.wc-block-cart-item__remove-link').html(btnText.replace("Artikel", "Produkt").replace("item", "product"));
            }
        }
    },100);
});